import React from 'react';
import { getApiUrl } from '../../config/api';

// Tamaño legible: B / KB / MB / GB con una decimal (los bytes van enteros).
// Un valor no numérico, no finito o negativo devuelve '' (nada que mostrar).
export function formatoTamano(bytes) {
  if (typeof bytes !== 'number' || !Number.isFinite(bytes) || bytes < 0) return '';
  if (bytes < 1024) return `${bytes} B`;
  const unidades = ['KB', 'MB', 'GB'];
  let valor = bytes / 1024;
  let i = 0;
  while (valor >= 1024 && i < unidades.length - 1) {
    valor /= 1024;
    i += 1;
  }
  return `${valor.toFixed(1)} ${unidades[i]}`;
}

const TEXTOS_ESTADO = {
  PENDIENTE: 'descargando…',
  DESCARGANDO: 'descargando…',
  NO_GUARDADO_CUOTA: 'no guardado: cuota llena',
  FALLO_DESCARGA: 'no se pudo descargar',
  RECHAZADO: 'tipo no admitido',
};

// Burbuja de archivo de un mensaje: el contenido si está guardado, o el estado.
// El JWT va en la cookie httpOnly, así que los elementos nativos siguen el 302.
// onCargado avisa cuando una imagen termina de cargar: ha crecido y el panel
// puede necesitar volver a bajar al final.
function MediaBubble({ msg, onCargado }) {
  if (msg.mediaFileId) {
    if (msg.mediaEstado === 'GUARDADO') {
      const src = getApiUrl(`/media/${msg.mediaFileId}`);
      switch (msg.messageType) {
        case 'image':
          return <img src={src} loading="lazy" alt={msg.fileName || 'imagen'} className="media-img" onLoad={onCargado} />;
        case 'sticker':
          return <img src={src} loading="lazy" alt={msg.fileName || 'imagen'} className="media-sticker" onLoad={onCargado} />;
        case 'video':
          return <video src={src} controls preload="none" />;
        case 'audio':
          return <audio src={src} controls preload="none" />;
        default:
          return (
            <a href={src} target="_blank" rel="noreferrer">
              📄 {msg.fileName || 'documento'}
              {msg.fileSize ? ` (${formatoTamano(msg.fileSize)})` : ''}
            </a>
          );
      }
    }
    const texto = TEXTOS_ESTADO[msg.mediaEstado];
    return texto ? <span className="media-estado">{texto}</span> : null;
  }
  if (msg.mediaAntigua) {
    return <span className="media-estado">archivo no disponible</span>;
  }
  return null;
}

export default MediaBubble;
